import { useState, useCallback } from 'react';

export const useNetworkError = () => {
  const [showNetworkError, setShowNetworkError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleNetworkError = useCallback((error, customMessage) => {
    // Check if it's a network error
    if (error?.code === 'NETWORK_ERROR' || 
        error?.message?.includes('Network Error') ||
        error?.message?.includes('network') ||
        !navigator.onLine ||
        error?.request) {
      
      setErrorMessage(customMessage || 'Unable to connect to the server. Please check your internet connection.');
      setShowNetworkError(true);
      return true;
    }
    return false;
  }, []);

  const hideNetworkError = useCallback(() => {
    setShowNetworkError(false);
    setErrorMessage('');
  }, []);

  const retryAction = useCallback((retryFunction) => {
    hideNetworkError();
    if (retryFunction && typeof retryFunction === 'function') {
      retryFunction();
    }
  }, [hideNetworkError]);

  return {
    showNetworkError,
    errorMessage,
    handleNetworkError,
    hideNetworkError,
    retryAction
  };
};
